angular
  .module('surfsightApp.controllers')
  .controller('healthReportsController', [
    '$scope',
    '$rootScope',
    '$log',
    '$state',
    '$timeout',
    '$interval',
    '$location',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$mdMedia',
    '$mdSidenav',
    '$mdToast',
    '$mdColors',
    'edgeFactory',
    'edgeGroupFactory',
    'leafletData',
    'nominatimLookUp',
    '$stateParams',
    function (
      $scope,
      $rootScope,
      $log,
      $state,
      $timeout,
      $interval,
      $location,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $mdMedia,
      $mdSidenav,
      $mdToast,
      $mdColors,
      edgeFactory,
      edgeGroupFactory,
      leafletData,
      nominatimLookUp,
      $stateParams
    ) {
      $scope.healthReportType = 1
      if ($stateParams.healthReportType) {
        $scope.healthReportType = parseInt($stateParams.healthReportType)
      }
      $scope.$on('healthReportType', function (e, data) {
        $scope.healthReportType = data.type
      })
      $scope.openReportDashboard = $mdMedia('gt-sm')
      if (!$mdMedia('gt-sm')) {
        $scope.healthReportType = false
        if ($stateParams.healthReportType) {
          $scope.healthReportType = parseInt($stateParams.healthReportType)
        }
        if ($scope.healthReportType) {
          $scope.openReportDashboard = true
        }
      }
      $http({
        method: 'GET',
        url:
          USER_BASEURL +
          '/organization/' +
          $localStorage.currentUserOrganization.id
      }).then(function (response) {
        if (response.data.status.code == 0) {
          $localStorage.userOrganization = response.data.organization
        }
      })
    }
  ])
